import { Pressable } from 'react-native'
import { styled } from '~/utils'

export const Trigger = styled(Pressable, () => {
  return {
    base: {},
  }
})
